// src/pages/profile/NotificationsPage.js
import React from "react";
import { useAuth } from "../../Utility/AuthProvider"; // Adjust path
import { FaEnvelope, FaBell, FaSms } from "react-icons/fa";

// A reusable component for a single notification setting
const NotificationToggle = ({ label, setting }) => (
  <div className="flex justify-between items-center p-4 border rounded-lg">
    <span className="font-medium text-gray-700">{label}</span>
    <div className="flex gap-4 items-center">
      <div
        className={`flex items-center gap-2 p-2 rounded-full ${setting.is_email ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-400"}`}
      >
        <FaEnvelope />
        <span>Email</span>
      </div>
      <div
        className={`flex items-center gap-2 p-2 rounded-full ${setting.is_push ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-400"}`}
      >
        <FaBell />
        <span>Push</span>
      </div>
      <div
        className={`flex items-center gap-2 p-2 rounded-full ${setting.is_sms ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-400"}`}
      >
        <FaSms />
        <span>SMS</span>
      </div>
    </div>
  </div>
);

const NotificationsPage = () => {
  const { user } = useAuth();
  const notifications = user?.notifications;

  if (!notifications) {
    return <div>Loading notification settings...</div>;
  }

  return (
    <div className="p-4 md:p-8 bg-gray-50 min-h-full">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Notification Settings
        </h1>
        <div className="bg-white p-6 rounded-lg shadow-md space-y-4">
          <NotificationToggle
            label="Rent Overdue"
            setting={notifications.rent_overdue}
          />
          <NotificationToggle
            label="Rent Paid"
            setting={notifications.rent_paid}
          />
          {/* Add more notification settings as they become available */}
        </div>
      </div>
    </div>
  );
};

export default NotificationsPage;
